import { Hint } from '@piggybank/form';
import T from 'prop-types';
import React from 'react';
import { MarkdownTranslation } from './Markdown';
import { TranslationScope } from './context';
import { formNameFromKeyPath, localizationKeyPath, requiredArg } from './utils';

export const DynamicFormHint = ({
  context = requiredArg('context'),
  formValues = {},
}) => {
  const { keyPath } = context;
  const sanitizedKeyPath = localizationKeyPath(keyPath);
  const currentFormValuePath = formNameFromKeyPath(keyPath).join('.');

  return (
    <TranslationScope path={sanitizedKeyPath}>
      <Hint>
        <MarkdownTranslation
          currentFormValuePath={currentFormValuePath}
          formValues={formValues}
          noBottomMargin={true}
          path="hint"
        />
      </Hint>
    </TranslationScope>
  );
};

DynamicFormHint.propTypes = {
  context: T.shape({
    keyPath: T.object,
    schemaPath: T.arrayOf(T.oneOfType([T.string, T.number])),
  }),
  formValues: T.object,
};
